import { ThemeProvider } from '@mui/material/styles';
import { useState } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import type { RunnerData } from '@/adapters/auth';
import { getRaceConfig } from '@/races';
import { RaceProvider } from '../../contexts/RaceContext';

export function RaceLayout() {
  const { raceAlias } = useParams<{ raceAlias: string }>();
  const [runner, setRunner] = useState<RunnerData | null>(null);

  if (!raceAlias) {
    return <Navigate to="/" replace />;
  }

  const race = getRaceConfig(raceAlias);

  if (!race) {
    return (
      <div>
        <h1>大会が見つかりません</h1>
        <p>指定された大会: {raceAlias}</p>
      </div>
    );
  }

  return (
    <ThemeProvider theme={race.theme}>
      <RaceProvider race={race} runner={runner} setRunner={setRunner}>
        <Outlet />
      </RaceProvider>
    </ThemeProvider>
  );
}
